<div class="footer-container">
    <div class="vertical-container fill-space">
        <img class="clickable logo" src="assets/logo.png" alt="Dogo Logo" />
        <br>
        <p>Dogo : Be at rest and let dogo handle your tasks</p>
    </div>
    <div class="vertical-container fill-space">
        <h3>Quick Links</h3>
        <br>
        <br>
        <span class="option">About Us</span>
        <span class="option">Download</span>
        <span class="option">Privacy Policy</span>
        <span class="option">Terms & Conditions</span>
    </div>
    <div class="vertical-container fill-space">
        <h3>Support</h3>
        <br>
        <br>
        <span class="option">Report a bug</span>
        <span class="option">Send Feedback</span>
        <span class="option">Contact Us</span>
        <span class="option">FAQs</span>
    </div>
    <div class="vertical-container fill-space">
        <h3>Newsletter</h3>
        <br>
        <br>
        <p>Subscribe to latest news, offers and updates from Dogo</p>
        <br>
        <br>
        <div class="horizontal-container">
            <input class="email-input" type="email" placeholder="Email" />
            <span style="width: 4px;"></span>
            <i class="fa fa-send"></i>
        </div>
    </div>
</div>
<div class="copyright-container">
    <p>Copyright © 2021 All rights reserved | Brought to you by Famenun Technologies Pvt. Ltd.</p>
</div>